import { useCallback, useMemo } from 'react'
import { useLocalStorage } from '@/hooks/useLocaleStorage'

function isDateInRange(startDate: Date, endDate: Date) {
  const today = new Date()
  return today >= startDate && today <= endDate
}

export interface BonusGiftType {
  id: string
  startDate: Date
  lastDateToEnter: Date
  winnerAnnouncedDate: Date
  imageUrl: string
  valueInPennies: number
}

const bonusGift: BonusGiftType = {
  id: 'bonus-prize-2',
  startDate: new Date('11/15/2024'),
  lastDateToEnter: new Date('11/17/2024'),
  winnerAnnouncedDate: new Date('11/27/2024'),
  imageUrl: 'https://images.angelstudios.com/image/upload/v1731708360/Bonus-Items-w02c_1.webp',
  valueInPennies: 49800,
}

export const useBonusGift = () => {
  const { startDate, lastDateToEnter, id } = bonusGift
  const { storedValue: hasSeenBonusGift, setStoredValue } = useLocalStorage(id, false, 'boolean')

  const isBonusGiftLive = isDateInRange(startDate, lastDateToEnter)

  const setHasSeenBonusGift = useCallback(() => {
    setStoredValue(true)
  }, [setStoredValue])

  return useMemo(() => {
    return {
      bonusGift,
      isBonusGiftLive,
      hasSeenBonusGift,
      setHasSeenBonusGift,
    }
  }, [hasSeenBonusGift, isBonusGiftLive, setHasSeenBonusGift])
}
